/**
 * Created by mykurisu on 2017/8/2.
 */
import React from 'react'
import {connect} from 'react-redux'
import {Button} from 'react-weui';
import axios from 'axios'

class ListenerManageBottom extends React.Component {

    constructor() {
        super();
        this.handlePassed = this.handlePassed.bind(this);
        this.handleRejected = this.handleRejected.bind(this);
        this.handleAllSelected = this.handleAllSelected.bind(this);
        this.handleNoneSelected = this.handleNoneSelected.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this)
    }

    handleConfirm() {
        const {listenermanage} = this.props;

        const noSelect = (listenermanage.tab === 0 && listenermanage.listener_list_passed_upload.length === 0) || 
                            (listenermanage.tab === 1 && listenermanage.listener_list_rejected_upload.length === 0);
        
        const noSelectText = listenermanage.tab === 0 ? '请选择需要取消授权的用户' : '请选择需要授权的用户';
        if (noSelect){
            this.context.page.showAlert(noSelectText);
            return
        }

        const text = listenermanage.tab === 0 ? '确定取消选中用户的听课权限？' : '确定授权选中用户的听课权限？'

        //弹窗二次确认 避免讲师操作失误
        this.context.page.showConfirm(
            '温馨提示',
            text,
            listenermanage.tab === 0 ? this.handleRejected : this.handlePassed,
            null,
            '再考虑',
            '确定'
        )
    }
    

    handlePassed() {
        const {listenermanage} = this.props;

        let data = new FormData();
        data.append('action', 'passed');
        for (let i = 0; i < listenermanage.listener_list_rejected_upload.length; i++) {
            data.append('account_id[]', listenermanage.listener_list_rejected_upload[i]);
        }
        axios.post(`/api/${listenermanage.url_data.type}/${listenermanage.url_data.id}/change_listener_status`, data)
            .then(res => {
                if (res.data.code === 0) {
                    let passedData = listenermanage.listener_passed;
                    let list = listenermanage.listener_passed_list;
                    let list_res = res.data.data;
                    passedData.sum_count += list_res.length;
                    list = list_res.concat(list);
                    for (let i = 0; i < list.length; i++) {
                        list[i].checked = false;
                        list[i].type = 'passed';
                    }
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_PASSED_INIT',
                        payload: passedData
                    });
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_PASSED_APPEND',
                        payload: list
                    });

                    let rejectedData = listenermanage.listener_rejected;
                    let list_rejected = listenermanage.listener_rejected_list;
                    rejectedData.sum_count -= list_res.length;
                    for (let i = 0; i < list_res.length; i++) {
                        let index = list_rejected.findIndex((value) => {
                            return value.id === list_res[i].id
                        });
                        list_rejected.splice(index, 1);
                    }
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_REJECTED_INIT',
                        payload: rejectedData
                    });
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_REJECTED_APPEND',
                        payload: list_rejected
                    });

                    this.props.dispatch({
                        type: 'LISTENER_LIST_REJECTED_CLEAR'
                    })
                } else {
                   this.context.page.showAlert(res.data.msg)
                }
            }).catch(err => {
                this.context.page.showAlert(err + '' || '未知错误')
            })
    }

    handleRejected() {
        const {listenermanage} = this.props;

        let data = new FormData();
        data.append('action', 'rejected');
        for (let i = 0; i < listenermanage.listener_list_passed_upload.length; i++) {
            data.append('account_id[]', listenermanage.listener_list_passed_upload[i]);
        }
        axios.post(`/api/${listenermanage.url_data.type}/${listenermanage.url_data.id}/change_listener_status`, data)
            .then(res => {
                if (res.data.code === 0) {
                    let rejectedData = listenermanage.listener_rejected;
                    let list = listenermanage.listener_rejected_list;
                    let list_res = res.data.data;
                    rejectedData.sum_count += list_res.length;
                    list = list_res.concat(list);
                    for (let i = 0; i < list.length; i++) {
                        list[i].checked = false;
                        list[i].type = 'rejected';
                    }
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_REJECTED_INIT',
                        payload: rejectedData
                    });
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_REJECTED_APPEND',
                        payload: list
                    });

                    let passedData = listenermanage.listener_passed;
                    passedData.sum_count -= list_res.length;
                    let list_passed = listenermanage.listener_passed_list;
                    for (let i = 0; i < list_res.length; i++) {
                        let index = list_passed.findIndex((value) => {
                            return value.id === list_res[i].id
                        });
                        list_passed.splice(index, 1);
                    }
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_PASSED_INIT',
                        payload: passedData
                    });
                    this.props.dispatch({
                        type: 'LISTENER_MANAGE_PASSED_APPEND',
                        payload: list_passed
                    });

                    this.props.dispatch({
                        type: 'LISTENER_LIST_PASSED_CLEAR'
                    })
                }
            })
    }

    handleAllSelected() {
        const {listenermanage} = this.props;
        if (listenermanage.tab === 0) {
            let list = listenermanage.listener_passed_list;
            let idList = [];
            for (let i = 0; i < list.length; i++) {
                list[i].checked = true;
                idList.push(list[i].id)
            }
            this.props.dispatch({
                type: 'LISTENER_LIST_CHANGE_PASSED',
                payload: idList
            });
            this.props.dispatch({
                type: 'LISTENER_MANAGE_PASSED_APPEND',
                payload: list
            });
        } else {
            let list = listenermanage.listener_rejected_list;
            let idList = [];
            for (let i = 0; i < list.length; i++) {
                list[i].checked = true;
                idList.push(list[i].id)
            }
            this.props.dispatch({
                type: 'LISTENER_LIST_CHANGE_REJECT',
                payload: idList
            });
            this.props.dispatch({
                type: 'LISTENER_MANAGE_REJECTED_APPEND',
                payload: list
            });
        }
    }

    handleNoneSelected() {
        const {listenermanage} = this.props;
        if (listenermanage.tab === 0) {
            let list = listenermanage.listener_passed_list;
            let idList = [];
            for (let i = 0; i < list.length; i++) {
                list[i].checked = false;
            }
            this.props.dispatch({
                type: 'LISTENER_LIST_CHANGE_PASSED',
                payload: idList
            });
            this.props.dispatch({
                type: 'LISTENER_MANAGE_PASSED_APPEND',
                payload: list
            });
        } else {
            let list = listenermanage.listener_rejected_list;
            let idList = [];
            for (let i = 0; i < list.length; i++) {
                list[i].checked = false;
            }
            this.props.dispatch({
                type: 'LISTENER_LIST_CHANGE_REJECT',
                payload: idList
            });
            this.props.dispatch({
                type: 'LISTENER_MANAGE_REJECTED_APPEND',
                payload: list
            });
        }
    }

    renderButton() {
        const {listenermanage} = this.props;
        if (listenermanage.tab === 0 && ((listenermanage.listener_list_passed_upload.length !== listenermanage.listener_passed_list.length) || listenermanage.listener_passed_list.length === 0)){
            return (
            <div className="listener-manage-bottom">
                <div className="listener-manage-bottom_item" onClick={this.handleAllSelected}>
                    <Button size="normal" type="primary" plain>
                        全选
                    </Button>
                </div>
                <div className="listener-manage-bottom_item" onClick={this.handleConfirm}>
                    <Button size="normal">
                        取消授权
                    </Button>
                </div>
            </div>
            )
        }else if (listenermanage.tab === 0 && (listenermanage.listener_list_passed_upload.length === listenermanage.listener_passed_list.length)){
            return (
                <div className="listener-manage-bottom">
                    <div className="listener-manage-bottom_item" onClick={this.handleNoneSelected}>
                        <Button size="normal" type="primary" plain>
                            取消全选
                        </Button>
                    </div>
                    <div className="listener-manage-bottom_item" onClick={this.handleConfirm}>
                        <Button size="normal">
                            取消授权
                        </Button>
                    </div>
                </div>
            )
        }else if (listenermanage.tab === 1 && ((listenermanage.listener_list_rejected_upload.length !== listenermanage.listener_rejected_list.length) || listenermanage.listener_rejected_list.length === 0)){
            return (
                <div className="listener-manage-bottom">
                    <div className="listener-manage-bottom_item" onClick={this.handleAllSelected}>
                        <Button size="normal" type="primary" plain>
                            全选
                        </Button>
                    </div>
                    <div className="listener-manage-bottom_item" onClick={this.handleConfirm}>
                        <Button size="normal">
                            授权
                        </Button>
                    </div>
                </div>
            )
        }else if (listenermanage.tab === 1 && (listenermanage.listener_list_rejected_upload.length === listenermanage.listener_rejected_list.length)){
            return (
                <div className="listener-manage-bottom">
                    <div className="listener-manage-bottom_item" onClick={this.handleNoneSelected}>
                        <Button size="normal" type="primary" plain>
                            取消全选
                        </Button>
                    </div>
                    <div className="listener-manage-bottom_item" onClick={this.handleConfirm}>
                        <Button size="normal">
                            授权
                        </Button>
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                {this.renderButton()}
            </div>
        )
    }
}

ListenerManageBottom.contextTypes = {
    page: React.PropTypes.object,
};

export default connect(state => ({
    listenermanage: state.listenermanage
}))(ListenerManageBottom)


// WEBPACK FOOTER //
// ./src/components/listenerManage/ListenerManageBottom.js